import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectNewbuildingAddress = (state: IApplicationState): string => {
  const { addressInfo } = selectNewbuilding(state);

  return addressInfo;
};
